import camelCaseToDash from "core-web/utils/camelCaseToDash";
import fontFamilies from "theme/config/fontFamilies";
import fontWeights from "theme/config/fontWeights";

// Need this to remove warning in textStyleToString
interface ObjectKeys {
    [key: string]: string | undefined;
}

export interface TextStyle extends ObjectKeys {
    fontFamily: string;
    fontStyle: string;
    fontSize: string;
    fontWeight?: string;
    letterSpacing?: string;
    lineHeight: string;
    textDecoration?: string;
    textTransform?: string;
}

export const textStyleToString = (textStyle: string) => {
    let css = "";
    const config = textStylesConfig[textStyle];

    if (config) {
        for (const key in config) {
            css += `${camelCaseToDash(key)}: ${config[key]};`;
        }
    }

    return css;
};

const textStylesConfig: Record<string, TextStyle> = {
    "Myriad Pro/96-100-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "96px",
        fontWeight: fontWeights.semibold,
        lineHeight: "100%",
        letterSpacing: "-0.03em",
    },
    "Myriad Pro/80-100-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "80px",
        fontWeight: fontWeights.semibold,
        lineHeight: "100%",
        letterSpacing: "-0.03em",
    },
    "Myriad Pro/64-110-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "64px",
        fontWeight: fontWeights.semibold,
        lineHeight: "110%",
        letterSpacing: "-1.92px", //em?
    },
    "Myriad Pro/64-100-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "64px",
        fontWeight: fontWeights.semibold,
        lineHeight: "100%",
        letterSpacing: "-0.03em",
    },
    "Myriad Pro/64-100": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "64px",
        fontWeight: fontWeights.regular,
        lineHeight: "100%",
        letterSpacing: "-0.03em",
    },
    "Myriad Pro/56-100-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "56px",
        fontWeight: fontWeights.semibold,
        lineHeight: "100%",
        letterSpacing: "-0.03em",
    },
    "Myriad Pro/56-100": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "56px",
        fontWeight: fontWeights.regular,
        lineHeight: "100%",
        letterSpacing: "-0.03em",
    },
    "Myriad Pro/48-120-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "48px",
        fontWeight: fontWeights.semibold,
        lineHeight: "120%",
        letterSpacing: "-0.03em",
    },
    "Myriad Pro/48-100-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "48px",
        fontWeight: fontWeights.semibold,
        lineHeight: "100%",
        letterSpacing: "-0.03em",
    },
    "Myriad Pro/48-100": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "48px",
        fontWeight: fontWeights.regular,
        lineHeight: "100%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/40-120-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "40px",
        fontWeight: fontWeights.semibold,
        lineHeight: "100%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/40-110-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "40px",
        fontWeight: fontWeights.semibold,
        lineHeight: "110%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/40-100-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "40px",
        fontWeight: fontWeights.semibold,
        lineHeight: "100%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/40-100": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "40px",
        fontWeight: fontWeights.regular,
        lineHeight: "100%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/32-120-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "32px",
        fontWeight: fontWeights.semibold,
        lineHeight: "120%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/32-100-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "32px",
        fontWeight: fontWeights.semibold,
        lineHeight: "100%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/28-130-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "28px",
        fontWeight: fontWeights.semibold,
        lineHeight: "130%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/24-130-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "24px",
        fontWeight: fontWeights.semibold,
        lineHeight: "130%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/24-120-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "24px",
        fontWeight: fontWeights.semibold,
        lineHeight: "120%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/24-100-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "24px",
        fontWeight: fontWeights.semibold,
        lineHeight: "100%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/24-140": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "24px",
        fontWeight: fontWeights.regular,
        lineHeight: "140%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/24-100": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "24px",
        fontWeight: fontWeights.regular,
        lineHeight: "100%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/22-140": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "22px",
        fontWeight: fontWeights.regular,
        lineHeight: "140%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/22-100": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "22px",
        fontWeight: fontWeights.regular,
        lineHeight: "100%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/20-140": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "20px",
        fontWeight: fontWeights.regular,
        lineHeight: "140%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/20-130-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "20px",
        fontWeight: fontWeights.semibold,
        lineHeight: "130%",
        letterSpacing: "-0.02em",
    },
    "Myriad Pro/20-100-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "20px",
        fontWeight: fontWeights.semibold,
        lineHeight: "100%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/20-100": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "20px",
        fontWeight: fontWeights.regular,
        lineHeight: "100%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/18-140": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "18px",
        fontWeight: fontWeights.regular,
        lineHeight: "140%",
    },
    "Myriad Pro/18-120-semibold": {
        fontFamily: fontFamilies.secondary,
        fontStyle: "normal",
        fontSize: "18px",
        fontWeight: fontWeights.semibold,
        lineHeight: "120%",
    },
    "Myriad Pro/18-100-semibold-semiextended": {
        fontFamily: fontFamilies.secondary,
        fontStyle: "normal",
        fontSize: "18px",
        fontWeight: fontWeights.semibold,
        lineHeight: "100%",
        letterSpacing: "-0.01em",
    },
    "Myriad Pro/18-100": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "18px",
        fontWeight: fontWeights.regular,
        lineHeight: "100%",
    },
    "Myriad Pro/16-140": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "16px",
        fontWeight: fontWeights.regular,
        lineHeight: "140%",
    },
    "Myriad Pro/16-120": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "16px",
        fontWeight: fontWeights.regular,
        lineHeight: "120%",
    },
    "Myriad Pro/16-100-semibold-semiextended": {
        fontFamily: fontFamilies.secondary,
        fontStyle: "normal",
        fontSize: "16px",
        fontWeight: fontWeights.semibold,
        lineHeight: "100%",
    },
    "Myriad Pro/16-100": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "16px",
        fontWeight: fontWeights.regular,
        lineHeight: "100%",
    },
    "Myriad Pro/14-140": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "14px",
        fontWeight: fontWeights.regular,
        lineHeight: "140%",
    },
    "Myriad Pro/14-100": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "14px",
        fontWeight: fontWeights.regular,
        lineHeight: "100%",
    },
    "Myriad Pro/14-100-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "14px",
        fontWeight: fontWeights.semibold,
        lineHeight: "100%",
    },
    "Myriad Pro/12-140": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "12px",
        fontWeight: fontWeights.regular,
        lineHeight: "140%",
    },
    "Myriad Pro/12-100-semibold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "12px",
        fontWeight: fontWeights.semibold,
        lineHeight: "100%",
    },
    "Myriad Pro/12-100": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "12px",
        fontWeight: fontWeights.regular,
        lineHeight: "100%",
    },

    "Buenos Aires/80-95 SemiBold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "80px",
        fontWeight: "600",
        lineHeight: "95%",
        letterSpacing: "-0.04em",
        textDecoration: "unset",
        textTransform: "unset",
    },

    "Buenos Aires/80-90 SemiBold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "80px",
        fontWeight: "600",
        lineHeight: "90%",
        letterSpacing: "-0.04em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Buenos Aires/64-90 SemiBold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "64px",
        fontWeight: "600",
        lineHeight: "90%",
        letterSpacing: "-0.03em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Buenos Aires/48-90 SemiBold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "48px",
        fontWeight: "600",
        lineHeight: "90%",
        letterSpacing: "-0.03em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Buenos Aires/40-100 SemiBold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "40px",
        fontWeight: "600",
        lineHeight: "100%",
        letterSpacing: "-0.02em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Buenos Aires/56-100 SemiBold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "56px",
        fontWeight: "600",
        lineHeight: "100%",
        letterSpacing: "-0.03em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Buenos Aires/24-110 SemiBold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "24px",
        fontWeight: "600",
        lineHeight: "110%",
        letterSpacing: "-0.02em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Buenos Aires/32-120 SemiBold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "32px",
        fontWeight: "600",
        lineHeight: "120%",
        letterSpacing: "-0.02em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Buenos Aires/20-120 Regular": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "120%",
        letterSpacing: "-0.02em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Buenos Aires/20-120 SemiBold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "20px",
        fontWeight: "600",
        lineHeight: "120%",
        letterSpacing: "-0.02em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Buenos Aires/20-110 SemiBold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "20px",
        fontWeight: "600",
        lineHeight: "110%",
        letterSpacing: "-0.02em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Buenos Aires/16-120 Regular": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "120%",
        letterSpacing: "-0.02em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Buenos Aires/16-120 SemiBold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "16px",
        fontWeight: "600",
        lineHeight: "120%",
        letterSpacing: "-0.02em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Buenos Aires/14-120 SemiBold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "14px",
        fontWeight: "600",
        lineHeight: "120%",
        letterSpacing: "-0.01em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Buenos Aires/14-120 Regular": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "120%",
        letterSpacing: "-0.01em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Buenos Aires/12-120 SemiBold": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "12px",
        fontWeight: "600",
        lineHeight: "120%",
        letterSpacing: "0em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Buenos Aires/12-120 Regular": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "120%",
        letterSpacing: "0em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Buenos Aires/10-120 Regular": {
        fontFamily: fontFamilies.primary,
        fontStyle: "normal",
        fontSize: "10px",
        fontWeight: "400",
        lineHeight: "120%",
        letterSpacing: "0em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Avenir/16-140 Medium": {
        fontFamily: fontFamilies.secondary,
        fontStyle: "normal",
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "140%",
        letterSpacing: "-0.01em",
        textDecoration: "unset",
        textTransform: "unset",
    },
    "Avenir/12-130 Medium": {
        fontFamily: fontFamilies.secondary,
        fontStyle: "normal",
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "130%",
        letterSpacing: "unset",
        textDecoration: "unset",
        textTransform: "unset",
    },
} as const;

export default textStylesConfig;
